import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../layout/form/Modal'
import 'bootstrap/dist/css/bootstrap.min.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ButtonGroup from '../../../layout/form/ButtonGroup';
import TextField from '../../../layout/form/TextField';
import common from '../../../common';

export class AddSMSTemplate extends Component {

    constructor(props) {
        super(props);
    
        this.state = { 
            sms:'',
            name:'',
            initial:true,
            id:0,
            isEdit: true,
            isUserAccess: false
        };

      };

    static getDerivedStateFromProps(prevProps,prevState) {
        var access = false
        if(prevProps.selectedRow && prevProps.selectedRow.id && prevState.initial){
            if(prevProps.userAccess && prevProps.userAccess.modifySMSTemplate){
                access = true
            }
            return {
                name:prevProps.selectedRow.name,
                sms: prevProps.selectedRow.body,
                id: prevProps.selectedRow.id,
                initial:false,
                isEdit: false,
                isUserAccess: access
            }
        }
        else if( prevState.initial){
            if(prevProps.userAccess && prevProps.userAccess.createSMSTemplate){
                access = true
            }
            return {
                initial:false,
                isUserAccess: access
            }
        }
        return null
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    handleEdit = () => {
        this.setState({
            isEdit: true
        })
    }

    editTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Edit
        </Tooltip>
    );

    render() {
        const {
            isAddNewSMSTemplateOpen, 
            handleModalClose,
            handleSaveAddNew,
            // selectedRow
        } = this.props;

        return (
            <div>
                <Modal
                    show ={isAddNewSMSTemplateOpen} 
                    onHide={handleModalClose}
                    title="Template Information"
                    width='60%'
                    body={
                        <div>
                            <div className="content-header" style={{margin:'-20px 0 15px 0'}}>
                                <div></div>
                                <div style={{display:'flex'}}>
                                    <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={this.editTooltip}
                                    >
                                        <span className="header-edit-icon" onClick={() => this.handleEdit()}>
                                            <ui5-icon class="samples-margin" name="edit" id="header-edit-icon"></ui5-icon>
                                        </span>
                                    </OverlayTrigger>
                                </div>
                            </div>
                            <form style={{marginTop:"5px"}}>
                                <div className='row'>
                                    <div className="col-sm">
                                        <TextField
                                            text="Name"
                                            onBlur={this.handleChange}
                                            controlId="name"
                                            type="text"
                                            defaultValue={this.state.name}
                                            maxLength={common.maxLengths.smsTemplateName}
                                            required
                                            disabled={!this.state.isEdit || !this.state.isUserAccess}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-sm">
                                        <TextField
                                            as="textarea"
                                            text="SMS"
                                            style={{ height: 100 }}
                                            onBlur={this.handleChange}
                                            controlId="sms"
                                            placeholder="SMS"
                                            type="text"
                                            defaultValue={this.state.sms}
                                            maxLength={300}
                                            disabled={!this.state.isEdit || !this.state.isUserAccess}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    }
                    footer={
                        <div>
                            <ButtonGroup
                                primaryBtnClick={handleModalClose}
                                primaryBtnVariant="outline-primary"
                                // primaryBtnText='Cancel'
                                // primaryBtnIcon='decline'
                                primaryBtnText='Go Back'
                                primaryBtnIcon='undo'
                                secondaryBtnClick={() => handleSaveAddNew(this.state)}
                                secondaryBtnText='Save'
                                secondaryBtnVariant="outline-primary" 
                                secondaryBtnIcon='save'
                                secondaryBtnDisabled={!this.state.isEdit || !this.state.isUserAccess}
                            />
                        </div>
                    }
                />
        </div>
        )
    }
}

AddSMSTemplate.propTypes = {
    isAddNewSMSTemplateOpen: PropTypes.bool,
    handleModalClose: PropTypes.func,
    handleSaveAddNew: PropTypes.func,
    selectedRow: PropTypes.any
}

export default AddSMSTemplate;